import React from 'react';
import Radium from 'radium';
import Badge from '@material-ui/core/Badge';
import { MuiThemeProvider } from '@material-ui/core';
import { UTButton } from '@widergy/energy-ui';
import { func } from 'prop-types';

import { accountPropTypes } from 'redux/accountHandlers';
import AccountSelect from 'app/components/AccountSelect';
import { message } from 'utils/stringUtils';
import SecondaryTopbar from 'app/components/SecondaryTopbar';
import { DefaultViewport, MobileViewport } from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

import AccountDetails from './components/AccountDetails';
import stylesJs, { theme } from './styles';
import styles from './styles.module.scss';

function AccountSelector({ onChangeAccount, onGoToAccounts, currentAccount, accounts }) {
  const addSupplies = appConfig.addSupplies && currentAccount && currentAccount.related_accounts;
  return (
    <div style={stylesJs.container}>
      <SecondaryTopbar titleText={message('AccountStatus:account')} style={stylesJs.accounts}>
        <DefaultViewport>
          <AccountSelect
            filterPlaceholder={message('AccountStatus:filterPlaceholder')}
            selectedOption={currentAccount}
            options={accounts}
            onSelect={onChangeAccount}
            keyProp="id"
            style={stylesJs.accountsSelector}
          />
        </DefaultViewport>
        <div style={stylesJs.myAccountsButton}>
          <MuiThemeProvider theme={theme}>
            <Badge badgeContent={addSupplies ? '!' : null} color={addSupplies ? 'primary' : ''}>
              <UTButton onPress={onGoToAccounts} className={styles.button}>
                {message('AccountStatus:myAccounts')}
              </UTButton>
            </Badge>
          </MuiThemeProvider>
        </div>
      </SecondaryTopbar>
      <MobileViewport>
        <AccountSelect
          filterPlaceholder={message('AccountStatus:filterPlaceholder')}
          selectedOption={currentAccount}
          dualLabel={['client_number', 'address']}
          options={accounts}
          onSelect={onChangeAccount}
          keyProp="id"
          style={stylesJs.accountsSelector}
        />
      </MobileViewport>
      {currentAccount && <AccountDetails account={currentAccount} />}
    </div>
  );
}

AccountSelector.propTypes = {
  onGoToAccounts: func.isRequired,
  onChangeAccount: func.isRequired,
  currentAccount: accountPropTypes,
  accounts: accountPropTypes
};

export default Radium(AccountSelector);
